import PicklistMetadata from "../PicklistMetadata";

class OrganizationPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "Organization";
        this.bounded = true;
        this.enterpriseComponent = "Organization";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = null;
        this.sortSpecification = {
            "Name": "DESC",
        };
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default OrganizationPicklistMetadata;
